<template>
  <div class="stage ion-activable" v-if="stage">
    <div
      style="display: flex; flex-direction: row; justify-content: space-between; margin-bottom: 1vh"
    >
      <div class="date">
        {{ $moment(stage.draw_at).format("dddd DD/MM/YYYY") }}
      </div>
      <div>Kỳ {{ stage.name }}</div>
    </div>

    <table class="prizes">
      <tr>
        <th>Giải Đặt Biệt</th>
      </tr>
      <tr>
        <td>
          <div class="jackpot">
            <span>{{ String(stage.results[0]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[1]).padStart(3,0) }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <th>Giải Nhất</th>
      </tr>
      <tr>
        <td>
          <div class="first">
            <span>{{ String(stage.results[2]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[3]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[4]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[5]).padStart(3,0) }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <th>Giải Nhì</th>
      </tr>
      <tr>
        <td>
          <div class="second">
            <span>{{ String(stage.results[6]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[7]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[8]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[9]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[10]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[11]).padStart(3,0) }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <th>Giải Ba</th>
      </tr>
      <tr>
        <td>
          <div class="third">
            <span>{{ String(stage.results[12]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[13]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[14]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[15]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[16]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[17]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[18]).padStart(3,0) }}</span>
            <span>{{ String(stage.results[19]).padStart(3,0) }}</span>
          </div>
        </td>
      </tr>
    </table>
    <ion-ripple-effect></ion-ripple-effect>
  </div>
</template>

<style scoped>
.stage {
  padding: 2vw;
  text-align: center;
}

.stage .date {
  text-transform: capitalize;
}

.prizes th {
  padding: 3px;
}

table {
  border-collapse: collapse;
}
table .text-right {
  text-align: right;
}

table td {
  padding: 5px;
}

.prizes {
  width: 100%;
}

.prizes th {
  font-weight: normal;
}

.prizes td > div {
  border: none;
  display: grid;
  justify-content: center;
  gap: 5px;
  grid-template-columns: auto auto;
  font-weight: bold;
  font-size: 1.1rem;
  letter-spacing: 2px;
}

.prizes .first {
  grid-template-columns: auto auto auto auto;
}

.prizes .second {
  grid-template-columns: auto auto auto auto auto auto;
}

.prizes .third {
  grid-template-columns: auto auto auto auto;
}

.prizes td > div > span {
  border: 1px solid #222;
  border-radius: 20px;
  padding: 2px 5px;
}

.prizes .jackpot > span {
  background-color: rgb(221, 0, 0);
  color: #fff;
  border: 1px solid rgb(221, 0, 0);
}

.prizes .first > span {
  background-color: rgb(168, 0, 160);
  color: #fff;
  border: 1px solid rgb(168, 0, 160);
}

.prizes .second > span {
  background-color: rgb(211, 84, 0);
  color: #fff;
  border: 1px solid rgb(211, 84, 0);
}


.prizes .third > span {
  background-color: rgb(2, 0, 134);
  color: #fff;
  border: 1px solid rgb(2, 0, 134);
}



</style>

<script>
import { defineComponent } from "vue";
import { IonRippleEffect } from "@ionic/vue";

export default defineComponent({
  name: "Max3dproResult",
  props: ["stage"],
  components: {
    IonRippleEffect,
  },
});
</script>
